export const iconMixin = {
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    size: {
      type: [String, Number],
      default: '16',
    },
  },
}
